import I18n from 'i18n-js';
import React from 'react';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';

import { isExperimentEnabled } from '@reverbdotcom/commons/src/user_context_helpers';
import experiments from '@reverbdotcom/commons/src/experiments';

import {
  withUserContext,
  IUserContext,
} from '@reverbdotcom/commons/src/components/user_context_provider';

const ACTIVE_CLASS = 'feed-container__tab--active';

type IProps = IUserContext;

export function FeedTabs(props: IProps) {
  const showRecommendations = isExperimentEnabled(
    props.user,
    experiments.WEB_RECOMMENDATIONS,
  );

  return (
    <nav className="feed-container__tabs">
      <ul>
        <li className="feed-container__tab">
          <CoreLink to="/my/feed" activeClassName={ACTIVE_CLASS}>
            {I18n.t('discovery.feed.tabs.feed')}
          </CoreLink>
        </li>
        <li className="feed-container__tab">
          <CoreLink to="/my/feed/customize" activeClassName={ACTIVE_CLASS}>
            {I18n.t('discovery.feed.tabs.customize')}
          </CoreLink>
        </li>
        <li className="feed-container__tab">
          <CoreLink to="/watched_products" activeClassName={ACTIVE_CLASS}>
            {I18n.t('discovery.feed.tabs.watchList')}
          </CoreLink>
        </li>
        <li className="feed-container__tab">
          <CoreLink to="/browsing_history" activeClassName={ACTIVE_CLASS}>
            {I18n.t('discovery.feed.tabs.recentlyViewed')}
          </CoreLink>
        </li>
        {showRecommendations &&
          <li className="feed-container__tab">
            <CoreLink to="/my/recommendations" activeClassName={ACTIVE_CLASS}>
              {I18n.t('discovery.feed.tabs.recommended')}
            </CoreLink>
          </li>
        }
      </ul>
    </nav>
  );
}

export default withUserContext<IProps>(FeedTabs);
